import { render, staticRenderFns } from "./FranchiseReport.vue?vue&type=template&id=a1d3f1f2&"
import script from "./FranchiseReport.vue?vue&type=script&lang=js&"
export * from "./FranchiseReport.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseReport.vue?vue&type=style&index=0&id=a1d3f1f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports